import { CourseMarkdown } from "@/components/storyboard/CourseMarkdown";
import InteractiveElementInlineCard from "@/components/interactive/InteractiveElementInlineCard";
import type { TextChecklistData } from "@/types/storyboard";

interface Props {
  data: TextChecklistData;
  title?: string;
}

/**
 * Checklist ("Aufgabenliste") storyboard block in the interactive-element card.
 */
export const TextChecklist = ({ data, title }: Props) => {
  const heading = data.title?.trim() || title?.trim() || undefined;

  return (
    <InteractiveElementInlineCard title={heading} illustrationKind="checklist">
      <div className="prose max-w-full text-primary mb-4">
        <CourseMarkdown>{data.introduction}</CourseMarkdown>
      </div>

      <div className="prose max-w-full mb-6 font-bold text-primary/70 prose-p:my-0">
        <CourseMarkdown>{data.instruction}</CourseMarkdown>
      </div>

      <div>
        {data.sections?.map((section, sectionIndex) => (
          <div key={sectionIndex} className="mb-6">
            <h3 className="mb-3">{section.heading}</h3>
            <ul className="list-none pl-0 space-y-2">
              {section.items.map((item, itemIndex) => (
                <li key={itemIndex}>
                  <label className="group flex items-center gap-3 -mx-2 px-2 py-1 rounded-lg hover:bg-primary/5 transition-colors cursor-pointer">
                    <input
                      type="checkbox"
                      aria-label={item}
                      className="h-5 w-5 shrink-0 cursor-pointer rounded border-2 border-primary accent-primary focus:ring-primary"
                    />
                    <span
                      className="prose prose-p:inline max-w-full"
                      aria-hidden="true"
                    >
                      <CourseMarkdown>{item}</CourseMarkdown>
                    </span>
                  </label>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </InteractiveElementInlineCard>
  );
};
